const HourGlass = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="hourglass-01">
      <path
        id="Icon"
        d="M9 9.59082L5.79533 6.92027C5.3192 6.52349 5.08113 6.32509 4.90998 6.0819C4.75833 5.86642 4.64572 5.62598 4.57726 5.37153C4.5 5.08436 4.5 4.77446 4.5 4.15467V2.09082M9 9.59082L12.2047 6.92027C12.6808 6.52349 12.9189 6.32509 13.09 6.0819C13.2417 5.86642 13.3543 5.62598 13.4227 5.37153C13.5 5.08436 13.5 4.77446 13.5 4.15467V2.09082M9 9.59082L5.79534 12.2614C5.3192 12.6582 5.08113 12.8565 4.90998 13.0997C4.75833 13.3152 4.64572 13.5557 4.57726 13.8101C4.5 14.0973 4.5 14.4072 4.5 15.027V17.0908M9 9.59082L12.2047 12.2614C12.6808 12.6582 12.9189 12.8565 13.09 13.0997C13.2417 13.3152 13.3543 13.5557 13.4227 13.8101C13.5 14.0973 13.5 14.4072 13.5 15.027V17.0908M3 2.09082H15M3 17.0908H15"
        stroke="#A4A7AE"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export default HourGlass;
